export const padTwo = (n: number) => n.toString().padStart(2, "0");

export const pluralize = (
  count: number,
  singular: string,
  plural = `${singular}s`,
) => (count === 1 ? singular : plural);

export const capitalize = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1);

/** "A, B and C", or "A, B and 3 more" once there are more than `shown`. */
export const listWithMore = (items: string[], shown: number): string => {
  if (items.length > shown)
    return `${items.slice(0, shown).join(", ")} and ${items.length - shown} more`;
  if (items.length <= 1) return items[0] ?? "";

  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
};

export const getInitials = (name?: string | null): string => {
  if (!name) return "";

  return name
    .trim()
    .split(/\s+/)
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

/** SCREAMING_SNAKE wire values into something a person would read. */
export const humanizeEnum = (value: string | undefined): string => {
  if (!value) return "";

  return value
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/** Case-insensitive substring match on any value; an empty query matches all. */
export const matchesQuery = (
  query: string | undefined,
  values: Array<string | null | undefined>,
): boolean => {
  const needle = query?.trim().toLowerCase();

  if (!needle) return true;

  return values.some((value) => value?.toLowerCase().includes(needle));
};
